module.exports = __webpack_public_path__ + "ECMv6/static/media/no-recent-item.0948ba9e.svg";